import { ref } from "vue";

type Theme = "light" | "dark";

const DEFAULT_THEME: Theme = "dark";

function readInitialTheme(): Theme {
  if (typeof window === "undefined") return DEFAULT_THEME;
  const stored = localStorage.getItem("theme") as Theme | null;
  return stored ?? DEFAULT_THEME;
}

const theme = ref<Theme>(readInitialTheme());

function applyTheme(value: Theme): void {
  theme.value = value;
  if (typeof document !== "undefined") {
    document.documentElement.classList.toggle("dark", value === "dark");
  }
  if (typeof localStorage !== "undefined") {
    localStorage.setItem("theme", value);
  }
}

if (typeof document !== "undefined") {
  document.documentElement.classList.toggle("dark", theme.value === "dark");
}

export function useTheme() {
  function toggleTheme(): void {
    applyTheme(theme.value === "dark" ? "light" : "dark");
  }

  return { theme, toggleTheme };
}
